"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntertainmentCommonHeaderSchema = exports.EntertainmentCommonAPIResponseSchema = void 0;
var zod_1 = require("zod");
var EntertainmentCommonAPIResponseSchema = function (bodySchema) {
    return zod_1.z.object({
        traceId: zod_1.z.string(),
        body: bodySchema,
        collection: zod_1.z.boolean(),
        contentType: zod_1.z.string(),
        page: zod_1.z.number().optional().nullable(),
    });
};
exports.EntertainmentCommonAPIResponseSchema = EntertainmentCommonAPIResponseSchema;
exports.EntertainmentCommonHeaderSchema = zod_1.z.object({
    platform: zod_1.z.string(),
    'Access-Token': zod_1.z.string(),
});
